<!-- eslint-disable vue/comma-dangle -->
<!-- packages/ui の TkCheckbox は scoped css コンポーネントからのデザイン指定が不可能なため、独自に作成 -->
<template>
  <div class="checkbox">
    <input
      :id="id"
      class="checkbox_input"
      type="checkbox"
      :checked="state"
      :disabled="disabled"
      @change="check($event.target.checked)"
    >
    <label
      :for="id"
      :class="[
        'checkbox_label',
        `-${size}`,
        `-${appearance}`,
        { '-checked': state },
        { '-disabled': disabled },
      ]"
    >
      <template v-if="$slots.label">
        <slot name="label" />
      </template>
      <span v-else>
        <del v-if="strikeThrough">{{ label }}</del>
        <template v-else>{{ label }}</template>
      </span>
    </label>
  </div>
</template>

<script>
import { uniq } from 'lodash'
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Checkbox',
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    selected: {
      type: [Array, Boolean],
      required: true,
    },
    value: {
      // selected に配列を渡す場合、このチェックボックスを ON にする候補を配列として複数指定できる
      // e.g. selected = ['11', '22', '33'], value = ['33', '44'] ⇒ チェックは ON
      //      selected = ['11', '22', '33'], value = ['44', '55'] ⇒ チェックは OFF
      // チェック状態が変化したときはそれぞれ和集合、差集合をペイロードとするイベントを emit する
      type: [String, Number, Array],
      default: null,
    },
    appearance: {
      type: String,
      default: 'checkbox',  // 'checkbox': 通常のチェックボックス、'button': 角丸ボタンのスタイル
    },
    size: {
      type: String,
      default: 'normal',  // 'normal', 'large'
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    strikeThrough: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    'id': `c-${uuidv4()}`,
  }),
  computed: {
    grouped() {
      return Array.isArray(this.selected)
    },
    values() {
      return Array.isArray(this.value) ? this.value : [this.value]
    },
    state() {
      return this.grouped
        ? this.selected.some(id => this.values.includes(id))
        : this.selected
    },
  },
  methods: {
    check(checked) {
      if (!this.grouped) {
        this.$emit('change', checked)
        return
      }

      const selected = checked
        ? uniq([...this.selected, ...this.values].sort())
        : this.selected.filter(id => !this.values.includes(id))
      this.$emit('change', selected)
    },
  },
}
</script>

<style scoped lang="scss">
.checkbox {
  display: flex;
  margin: 0;  // bootstrap css の打ち消し
  align-items: center;
}

.checkbox_input {
  display: none;
}

.checkbox_label {
  font-weight: 600;
  cursor: pointer;

  &.-checkbox {
    &.-normal {
      padding: 7px 0 7px 30px;
      font-size: 11px;
    }
    // 未使用 必要になったら定義
    &.-large {
      padding: 7px 0 7px 30px;
      font-size: 12px;
    }

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 16px;
      height: 16px;
      transform: translateY(-50%);
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      background: url(~@ota-frontend/static-tour/src/assets/checkbox.svg);
    }
    &.-checked::before {
       background: url(~@ota-frontend/static-tour/src/assets/checkbox01.svg);
    }
  }

  &.-button {
    background-color: #fefefe;
    border-radius: 30px;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);

    // 未使用 必要になったら定義
    &.-normal {
      padding: 6px 14px;
      font-size: 11px;
    }
    &.-large {
      padding: 8px 20px;
      font-size: 12px;
    }

    &.-checked {
      background-color: #1f6aad;
      color: white;
    }
  }

  &.-disabled {
    opacity: .5
  }
}
</style>
